var currencyFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
});

var currencyTwoDigitsFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

function onPlanChanged() {
  $('.label-text').removeClass('checked-text');
  $('.price').removeClass('active-price');

  var checked = $('.regular-radio:checked');
  checked.parent().find('.label-text').addClass('checked-text');
  checked.parent().find('.price').addClass('active-price');

  var amount = checked.val();
  var price = parseInt(checked.parent().find('[name="price"]').val());
  var totalPrice, subtotalPrice;
  totalPrice = subtotalPrice = parseInt(checked.parent().find('[name="totalPrice"]').val());
  var discount = parseInt($('#summary-discount-price').val());
  if (!isNaN(discount)) {
    totalPrice -= discount;
  }
  var formattedPrice = currencyFormatter.format(price / 100).replace(/^US/, '') + ' x ' + amount;
  var formattedTotalPrice = currencyTwoDigitsFormatter.format(totalPrice / 100).replace(/^US/, '');
  var formattedSubtotalPrice = currencyTwoDigitsFormatter.format(subtotalPrice / 100).replace(/^US/, '');

  $('#summary-info').text(formattedPrice);
  $('#summary-subtotal').text(formattedSubtotalPrice);
  $('#summary-total').text(formattedTotalPrice);
}

$(document).ready(function() {
  $('.regular-radio').change(onPlanChanged);
  $('.regular-radio').first().prop('checked', true);
  onPlanChanged();
});